import { parseQuery } from "../utils/query";

const queryParams = (() => {
    console.log('Query parameters parsed');
    return parseQuery(window.location.search.substring(1));
})();

export default queryParams;
